import { render } from "./BabyTeeth.vue?vue&type=template&id=6ac03a10&scoped=true"
import script from "./BabyTeeth.vue?vue&type=script&lang=js"
export * from "./BabyTeeth.vue?vue&type=script&lang=js"

import "./BabyTeeth.vue?vue&type=style&index=0&id=6ac03a10&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac03a10"]])

export default __exports__